import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "utils/constants";

import Button from "components/Button";
import Container from "components/Container";
import Content from "components/Content";
import Editor from "components/Editor";
import Footer from "components/Footer";
import { Form, FormField } from "components/Form";
import Header from "components/Header";
import Input from "components/Input";
import Label from "components/Label";
import MainMenu from "components/MainMenu";

import CancelReportTemplateDialog from "../CancelReportTemplateDialog";

import { useReportTemplate } from "./useReportTemplate";

export default function ReportTemplate() {
  const { t } = useTranslation();
  const { form, onSubmit, handleSubmit, handleCancel, isCancelOpen, setIsCancelOpen, isLoadingReportTemplate } =
    useReportTemplate();

  const {
    control,
    formState: { isDirty },
  } = form;

  return (
    <>
      <Header className="justify-between">
        <div className="flex items-center gap-2">
          <Link to={ROUTES.PROFILE_REPORT_TEMPLATES} className="flex items-center cursor-pointer">
            <ArrowLeftIcon />
          </Link>
          {t("menu.reportTemplates")}
        </div>
        <MainMenu />
      </Header>
      <Content isLoading={isLoadingReportTemplate}>
        <Container>
          <Form {...form}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col justify-between px-4 md:px-0 pt-5 mb-20 md:mb-0"
              id="report-template-form"
            >
              <div className="flex flex-col gap-3.5 w-full">
                <FormField
                  control={control}
                  name="name"
                  render={({ field }) => (
                    <Input
                      {...field}
                      label={t("profile.reportTemplate.name")}
                      placeholder={t("profile.reportTemplate.name")}
                    />
                  )}
                />
                <FormField
                  control={control}
                  name="description"
                  render={({ field }) => (
                    <Input
                      {...field}
                      label={t("profile.reportTemplate.description")}
                      placeholder={t("profile.reportTemplate.description")}
                    />
                  )}
                />
                <FormField
                  control={control}
                  name="content"
                  render={({ field }) => (
                    <div className="flex flex-col gap-1.5">
                      <Label>{t("profile.reportTemplate.content")}</Label>
                      <Editor content={field.value} onChange={field.onChange} />
                    </div>
                  )}
                />
              </div>
              <Footer className="md:justify-end gap-4">
                <Button
                  className="flex-1 md:flex-none  md:w-60"
                  type="button"
                  variant="secondary"
                  onClick={handleCancel}
                >
                  {t("button.cancel")}
                </Button>
                <CancelReportTemplateDialog open={isCancelOpen} setOpen={setIsCancelOpen} />
                <Button className="flex-1 md:flex-none md:w-60" type="submit" variant="primary" disabled={!isDirty}>
                  {t("button.save")}
                </Button>
              </Footer>
            </form>
          </Form>
        </Container>
      </Content>
    </>
  );
}
